"use server";

import { redirect } from "next/navigation";
import { revalidatePath } from "next/cache";
import { prisma } from "@/lib/prisma";
import { belepesKotelezo, szerepkorKotelezo } from "@/lib/auth";
import { hirlevelKuldes } from "@/lib/email";

export async function hirlevelFeliratkozas(formData: FormData) {
  const email = String(formData.get("email") || "").trim().toLowerCase();
  const nev = String(formData.get("nev") || "").trim() || null;
  const oldal = String(formData.get("vissza_oldal") || "/ajanlatkeres");

  if (!email) {
    redirect(`${oldal}?hirlevel_hiba=1#hirlevel`);
  }

  try {
    await prisma.hirlevelFeliratkozo.create({ data: { email, nev } });
  } catch {
    // mar feliratkozott email - felhasznaloi szempontbol ez is sikeres allapot
  }

  redirect(`${oldal}?hirlevel_siker=1#hirlevel`);
}

export async function hirlevelFeliratkozoTorlese(formData: FormData) {
  await belepesKotelezo();

  const id = String(formData.get("id") || "");
  if (!id) return;

  await prisma.hirlevelFeliratkozo.delete({ where: { id } });

  revalidatePath("/admin/hirlevel");
}

export async function hirlevelKampanyKikuldese(formData: FormData) {
  await szerepkorKotelezo("ADMIN", "CEGVEZETO", "MARKETING");

  const targy = String(formData.get("targy") || "").trim();
  const torzs = String(formData.get("torzs") || "").trim();
  if (!targy || !torzs) redirect("/admin/hirlevel?kampany_hiba=hianyzo_adat");

  const feliratkozok = await prisma.hirlevelFeliratkozo.findMany({ select: { email: true } });
  const eredmeny = await hirlevelKuldes(targy, torzs, feliratkozok.map((f) => f.email));

  if (eredmeny.hiba) {
    redirect(`/admin/hirlevel?kampany_hiba=${encodeURIComponent(eredmeny.hiba)}`);
  }

  redirect(`/admin/hirlevel?kampany_siker=${eredmeny.kikuldott}&kampany_sikertelen=${eredmeny.sikertelen}`);
}
